import React, { ReactNode } from 'react';
import { Grid, Paper } from '@mui/material';
import SearchResultCounter from './SearchResultCounter';
import SearchActionButtons from './SearchActionButtons';

interface SearchControlsLayoutProps {
  children?: ReactNode;
  count?: number;
  onClear?: () => void;
  searchLabel?: string;
  clearLabel?: string;
  leftSlot?: ReactNode;
}

/**
 * 検索フォームのレイアウトを管理するコンポーネント
 * ペーパーコンポーネントでラップして余白を追加
 * 
 * 2つの使用方法をサポートしています:
 * 1. childrenを提供する場合: 単純にラップするだけ
 * 2. count, onClearなどを提供する場合: 従来の3カラムレイアウトを構築
 */
const SearchControlsLayout: React.FC<SearchControlsLayoutProps> = ({
  children,
  count,
  onClear,
  searchLabel = '検索',
  clearLabel = 'クリア',
  leftSlot
}) => {
  // childrenが提供されている場合、単純なラッパーとして機能
  if (children) {
    return (
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        {children}
      </Paper>
    );
  }
  
  // 従来のレイアウト（count, onClearなどが提供された場合）- シャドウなし
  return (
    <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>
      <Grid item xs={5} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        {leftSlot}
      </Grid>
      <Grid item xs={2} sx={{ textAlign: 'center' }}>
        {count !== undefined && <SearchResultCounter count={count} />}
      </Grid>
      <Grid item xs={5}>
        {onClear && (
          <SearchActionButtons
            onClear={onClear}
            clearLabel={clearLabel}
            searchLabel={searchLabel}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default SearchControlsLayout;